import {Pipe, PipeTransform} from '@angular/core';

export type Address = {
    line?: string | string[];
    city?: string;
    state?: string;
    zip?: string;
};

@Pipe({name: 'address'})
export class AddressPipe implements PipeTransform {
    transform(value: Address): string {
        if (!value || Object.keys(value).length === 0) {
            return '-';
        }
        const line = value.line ? (Array.isArray(value.line) ? value.line.filter(Boolean).join(', ') : value.line) : '';
        const parts = [line, value.city, value.state, value.zip].filter(Boolean);
        return parts.length > 0 ? parts.join(', ') : '-';
    }
}
